import React, { forwardRef, Ref, useContext } from 'react'
import InputLabel from './input-label'
import { PopupCloseContext, UserInitalValue } from '../../store/contexts/popupclose-context'
const InputSearch = forwardRef((inputProps:any,ref:Ref<HTMLInputElement>) => {
  const { setMultiplePopup }: typeof UserInitalValue = useContext(PopupCloseContext)

  const closeOpenPopups = () => {
    setMultiplePopup?.(null)
  }

  const handleSearchClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    closeOpenPopups()
    ;(inputProps?.onSearchClick || inputProps?.onClick)?.(event)
  }

  const handleInputFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    closeOpenPopups()
    inputProps?.onFocus?.(event)
  }

  const handleInputClick = (event: React.MouseEvent<HTMLInputElement>) => {
    closeOpenPopups()
    inputProps?.onClick?.(event)
  }

  return (
    <div className={inputProps?.formClassName}>
      {inputProps?.label && <InputLabel labelProps={{ htmlFor: inputProps?.inputProps?.id }} label={inputProps?.label} className={inputProps?.inputProps?.className} infoLabel={inputProps?.info} isinfoLabel={inputProps?.isInfo} isinfoIcon={inputProps?.infoIcon} isinfoClassName={inputProps?.infoClassName} labelclassName ={inputProps?.labelclassName} mandatory={inputProps?.isMandatory}/>}
      <div className={inputProps?.searchgroup}>
      {inputProps?.icon && <a onClick={handleSearchClick}><span className={inputProps?.licon}></span></a>}
      <input
        name={inputProps?.inputProps?.name}
        id={inputProps?.inputProps?.id}
        value={inputProps?.inputProps?.value}
        maxLength={inputProps?.inputProps?.maxLength}
        onChange={inputProps?.onChange}
        onKeyDown={inputProps?.onKeyDown}
        onFocus={handleInputFocus}
        onClick={handleInputClick}
        disabled={inputProps?.disabled}
        readOnly={inputProps?.readonly}
        className={inputProps?.className}
        style={inputProps?.style}
        aria-label={inputProps['aria-label'] || inputProps?.inputProps?.arialabel || inputProps?.label}
        aria-required={inputProps?.isMandatory}
        size={inputProps?.inputProps?.size || 'sm'}
        type={inputProps?.type || 'search'}
        placeholder={inputProps?.inputProps?.placeholder}
        ref={ref}
      />
      {inputProps?.icon && <a onClick={handleSearchClick} title={inputProps?.inputProps?.placeholder || inputProps?.label || 'Search'}><span className={inputProps?.icon}></span></a>}
      </div>
      </div>
  )
})
export default InputSearch
